// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dashboard-header{z-index:6}.dashboard-header .input-container,.dashboard-header .video-search{width:400px !important;max-width:100%}.dashboard-header .header-left,.dashboard-header .header-center,.dashboard-header .header-right{width:220px}@media screen and (max-width: 970px){.dashboard-header .header-left{width:0 !important}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
